import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';

const initialState = {
  languagesList: [],
  payorsList: [],
  facilityListForPayor: [],
  companyConnectionForPayor: [],
  levelOfServicesForPayor: [],
  billingItemsForPayor: [],
  levelOfServicesForTripForm: [],
  billingItemsForTripForm: []
};
const listsReducer = createSlice({
  name: 'lists',
  initialState,
  reducers: {
    getMedicalDiagnosticsList(state, action) {
      const newArr = [...action.payload?.data].map((item) => {
        return {
          id: item.id,
          optionValue: `(${item.name}) ${item.description}`
        };
      });
      return {
        ...state,
        medicalDiagnosticsList: newArr ? newArr : [{ name: '' }]
      };
    },
    getLanguages(state, action) {
      return {
        ...state,
        languagesList: action.payload?.data
      };
    },
    getPayorsList(state, action) {
      return {
        ...state,
        payorsList: action.payload?.data?.data
      };
    },
    getCompatibleInsurancesList(state, action) {
      return {
        ...state,
        compatibleInsurancesList: action.payload?.data
      };
    },
    getZipCodeGroupsList(state, action) {
      return {
        ...state,
        zipCodeGroupsList: action.payload?.data
      };
    },
    getFacilityListForPayor(state, action) {
      return {
        ...state,
        facilityListForPayor: action.payload?.data
      };
    },
    getCompanyConnectionForPayor(state, action) {
      return {
        ...state,
        companyConnectionForPayor: action.payload?.data
      };
    },
    getLevelOfServicesForPayor(state, action) {
      return {
        ...state,
        levelOfServicesForPayor: action.payload?.data
      };
    },
    getBillingItemsForPayor(state, action) {
      return {
        ...state,
        billingItemsForPayor: action.payload?.data
      };
    },
    getBillingItemsForTripForm(state, action) {
      return {
        ...state,
        billingItemsForTripForm: action.payload?.data
      };
    },
    getLevelOfServicesForTripForm(state, action) {
      return {
        ...state,
        levelOfServicesForTripForm: action.payload?.data
      };
    }
  }
});

export default listsReducer.reducer;

export const listsReducerActions = listsReducer.actions;

export const getMedicalDiagnosticsList = (data) => async (dispatch) => {
  try {
    const res = await api.get(`api/MedicalDiagnosisCode`, {
      params: data,
      paramsSerializer: {
        indexes: true // use brackets with indexes
      }
    });
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getMedicalDiagnosticsList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const getLanguages = () => async (dispatch) => {
  try {
    const res = await api.get(`api/PreferredLanguage`);
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getLanguages(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const getPayorsList = (data) => async (dispatch) => {
  try {
    const res = await api.get(`api/Payor`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getPayorsList(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getCompatibleInsurancesList = () => async (dispatch) => {
  try {
    const res = await api.get(`api/CompatibleInsurance`);
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getCompatibleInsurancesList(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getZipCodeGroupsList = () => async (dispatch) => {
  try {
    const res = await api.get(`api/ZipCodeGroups`);
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getZipCodeGroupsList(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getFacilityListForPayor = () => async (dispatch) => {
  try {
    const res = await api.get(`api/Facility/GetForPayor`);
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getFacilityListForPayor(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const getCompanyConnectionForPayor = () => async (dispatch) => {
  try {
    const res = await api.get(`api/CompanyConnection/GetForPayor`);
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getCompanyConnectionForPayor(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getLevelOfServicesForPayor = (payorId) => async (dispatch) => {
  try {
    const res = await api.get(`api/LevelOfService/GetForPayor`, {
      params: { payorId }
    });
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getLevelOfServicesForPayor(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const getBillingItemsForPayor = (payorId) => async (dispatch) => {
  try {
    const res = await api.get(`api/BillingItem/GetForPayor`, {
      params: { payorId }
    });
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getBillingItemsForPayor(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getLevelOfServicesForTripForm = (fromId) => async (dispatch) => {
  try {
    const res = await api.get(`api/LevelOfService/GetByFormId`, {
      params: { fromId }
    });
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getLevelOfServicesForTripForm(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getBillingItemsForTripForm = (fromId) => async (dispatch) => {
  try {
    const res = await api.get(`api/BillingItem/GetByFormId`, {
      params: { fromId }
    });
    if (res.status === 200 && res?.data) {
      dispatch(listsReducerActions.getBillingItemsForTripForm(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
